// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BorderOutlined,
  BoxPlotOutlined,
  // ChromeOutlined,
  DeploymentUnitOutlined,
  GatewayOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  SmileOutlined,
  StopOutlined,
  UserOutlined,
  SettingOutlined,
  AimOutlined,
  RadarChartOutlined,
  StarOutlined,
  TeamOutlined,
  ProjectOutlined,
  BuildOutlined
} from '@ant-design/icons';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AutoAwesome from '@mui/icons-material/AutoAwesome';

// icons
const icons = {
  AutoAwesome,
  RadarChartOutlined,
  MenuUnfoldOutlined,
  BoxPlotOutlined,
  StopOutlined,
  BorderOutlined,
  SmileOutlined,
  GatewayOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  UserOutlined,
  SettingOutlined,
  AimOutlined,
  StarOutlined,
  TeamOutlined,
  ProjectOutlined,
  BuildOutlined,
  TrendingUpIcon
};
// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other = {
  id: 'other',
  // title: <FormattedMessage id="others" />,
  type: 'group',
  children: [
    {
      id: 'agent',
      title: <FormattedMessage id="ai-agent" />,
      type: 'item',
      url: '/agent',
      icon: icons.AutoAwesome,
      breadcrumbs: false
    },
    // {
    //   id: 'tools',
    //   title: <FormattedMessage id="tools" />,
    //   type: 'item',
    //   url: '/tools',
    //   icon: icons.ProjectOutlined,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'projects',
    //   title: <FormattedMessage id="projects" />,
    //   type: 'item',
    //   url: '/projects',
    //   icon: icons.BuildOutlined,
    //   breadcrumbs: false
    // },
    {
      id: 'lp-analysis',
      title: <FormattedMessage id="lp-analysis" />,
      type: 'item',
      url: '/lp-analysis',
      icon: icons.RadarChartOutlined,
      breadcrumbs: false
    },
    {
      id: 'competitors-history',
      title: <FormattedMessage id="competitors-history" />,
      type: 'item',
      url: '/competitors-history',
      icon: icons.AimOutlined,
      breadcrumbs: false
    },
    {
      id: 'reviews',
      title: <FormattedMessage id="reviews" />,
      type: 'item',
      url: '/reviews',
      icon: icons.StarOutlined,
      breadcrumbs: false
    },
    {
      id: 'interviews',
      title: <FormattedMessage id="interviews" />,
      type: 'item',
      url: '/interviews',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'icp-generator',
      title: <FormattedMessage id="icp-generator" />,
      type: 'item',
      url: '/icp-generator',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'market-trends',
      title: <FormattedMessage id="market-trends" />,
      type: 'item',
      url: '/market-trends',
      icon: icons.TrendingUpIcon,
      breadcrumbs: false
    }
  ]
};

export default other;
